import { render, staticRenderFns } from "./LeadBoardColumnHeader.vue?vue&type=template&id=5f8a61cb&"
import script from "./LeadBoardColumnHeader.vue?vue&type=script&lang=js&"
export * from "./LeadBoardColumnHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports